<template>
  <div>
    <div v-if="!round" :class="dropdown ? 'dropdown' : '' ">
      <button 
        v-if="icon" :title="toolTip?toolTip:''"
        :data-cy="CY"
        :class="{
          button: true,
          disableBtn: disable===true,
          outlineDesign: !roundedSquare && outline,
          xSmallButton: xSmall === true,
          largeButton: large === true,
          smallButton: small === true,
          ...roundedSquareClasses,
          'border-left': borderL
        }"
        :style="{'background-color':buttonColor ? buttonColor:transparent,color:fontColor ? fontColor : black } "
        @click="() => emitClickedItem(title)">
        <img :src="getImgUrl(icon)" :style="{
            'opacity': iconOpacity,
            'position': 'inherit',
            'margin-top': '2px',
            'margin-left': '2px',
            'margin-right': '2px',
          }
          " width="20px" height="20px" />
      </button>
      <button 
          v-else 
          :data-cy="CY"
          :class="{
          disableBtn: disable == true,
          button: true,
          smallButton: small == true,
          xSmallButton: xSmall === true,
          largeButton: large === true,
          pillDesign: pill == true,
          setRadius: pill == true && small == false && xSmall == false && large == false,
          outlineDesign: outline == true,
          dropdownDesign: dropdown == true
        }" :style="{
          btnStyles,
         'background-color':buttonColor ? buttonColor:transparent,
         color:fontColor ? fontColor : black
      }" type="button" :title="toolTip?toolTip:''" @click="() => emitClickedItem(title)">
        {{ title }}
        <i id="caret" v-if="dropdown" class="fa fa-angle-down img"></i>
      </button>

      <div v-if="dropdown" class="dropdown-content" @mouseleave="originalImage" @mouseenter="constantImage">
        <ul v-for="(content, i) in dropdownOptions" :key="i" @click="() => emitClickedItem(content)">
          <li :class="{
              onlyBottom: i != 0,
              buttonDiv: i == 0,
              dropdownLabel: label == true,
            }">
            {{ content }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="round">
      <button
        v-if="icon"
        :data-cy="CY"
        :title="toolTip?toolTip:''"
        :class="{
          round: true,
          smallButton: small,
          xSmallButton: xSmall,
          largeButton: large,
          'mini-button': mini
        }"
        @click="() => emitClickedItem(title)">
        <img :src="getImgUrl(icon)" class="icon" />
      </button>
      <button v-if="!icon" :data-cy="CY" class="round round-title" :title="toolTip?toolTip:''" @click="() => emitClickedItem(title)">
        {{ title }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SButton",

    data() {
      return {
        open: true,
        label: true,
        toolTipFlag: false,
      };
    },

    props: {
      CY: String,
      title: {
        type: String,
        required: true,
      },
      disable: {
        type: Boolean,
        required: false,
        default: false,
      },
      small: {
        type: Boolean,
      },
      xSmall: {
        type: Boolean,
      },
      large: {
        type: Boolean,
      },
      fontColor: {
        type: String,
      },
      buttonColor: {
        type: String,
      },
      pill: {
        type: Boolean,
      },
      outline: {
        type: Boolean,
      },
      dropdown: {
        type: Boolean,
      },
      dropdownOptions: {
        type: Array,
        required: false,
      },
      round: {
        type: Boolean,
      },
      icon: {
        type: String,
      },
      toolTip: {
        type: String,
      },
      fontSize: {
        type: String,
      },
      padding: {
        type: String,
      },
      mini: {
        default: false
      },
      roundedSquare: {
        default: false
      },
      rightBordersSquare: {
        default: false,
      },
      leftBordersSquare: {
        default: false,
      },
      iconOpacity: {
        default: 0.5
      },
      borderL: {},

    },

    mounted() {
    },

    methods: {
      changeImage() {
        var icon = document.getElementById("caret");
        if (this.open) {
          icon.className = "fa fa-angle-down open img";
        } else {
          icon.className = "fa fa-angle-down img  ";
        }

        this.open = !this.open;
      },

      emitClickedItem(name) {
        this.$emit("clicked-item", name);
        this.$emit("click");
      },

      constantImage() {
        var icon = document.getElementById("caret");
        icon.className = "fa fa-angle-down open img  ";
      },

      originalImage() {
        var icon = document.getElementById("caret");
        icon.className = "fa fa-angle-down img  ";
        this.open = !this.open;
      },

      getImgUrl(icon) {
        return require("../assets/" + icon);
      },


    },
    computed: {
      roundedSquareClasses() {
        return {
          'rounded-square': this.roundedSquare,
          'left-borders-square': this.leftBordersSquare,
          'right-borders-square': this.rightBordersSquare,
        }
      },
      btnStyles() {
        let fntSz, padd;

        fntSz = '14px';
        padd = "16px";

        if (this.fontSize) {
          fntSz = this.fontSize + "px";
        }
        if (this.padding) {
          padd = this.padding;
        }
        return {
          "font-size": fntSz + "!important",
          "padding": padd
        };

      },
    }
  };
</script>

<style scoped lang="scss">

  .outlineDesign {
    background-color: #ffffff !important;
    border: 1px solid var(--brown-grey) !important;
  }
  .outlineDesign:hover {
    border: 1px solid transparent;
  }
  .button {
    width: 100% !important;
    padding: 16px;
    cursor: pointer;
      font-family: "Roboto !important";
    // font-size: 14px;
    font-weight: bold;
    background-color: #d8d8d8;
    color: hsl(0, 0%, 0%);
    border: 1px solid transparent;
    outline: 0;
  }

  .button:hover,
  .smallButton:hover {
    border: 1px solid transparent;
    outline: none !important;
    background-color: var(--primary) !important;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.4s;
  }


  .button:active {
    background-color: var(--primary-hover) !important;
    border-style: groove !important;
    border-width: 0.5px !important;
  }
  

  .smallButton {
    padding: 10px !important;
    font-size: 12px;
  }
  .xSmallButton {
    padding: 8px !important;
    font-size: 10px;
  }
  .xSmallButton:hover {
    border: 1px solid transparent;
    outline: none !important;
    background-color: var(--primary) !important;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.4s;
  }

  .largeButton {
    padding: 8px 40px 8px 40px !important;
    font-size: 12px;
  }
  .largeButton:hover {
    border: 1px solid transparent;
    outline: none !important;
    background-color: var(--primary) !important;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.4s;
  }


  .mini-button {
    padding: 2px !important;
    font-size: 10px;
  }

  .pillDesign {
    border-radius: 16px;
  }

  .setRadius {
    border-radius: 24px !important;
  }

  .pillDesign:hover {
    color: #ffffff !important;
    background-color: var(--secondary) !important;
  }

  .pillDesign:active {
    background-color: #1a1a1a !important;
    border-style: groove !important;
    border-width: 0.5px !important;
  }

  

  .dropdownDesign .img {
    top: 2px !important;
    font-size: medium !important;
  }

  .dropdownDesign:hover {
    border-radius: 0px !important;
    background-color: #d8d8d8 !important;
    color: #000000 !important;
  }

  .disableBtn {
    cursor: not-allowed !important;
    opacity: 0.65 !important;
    border-bottom: none !important;
    outline: 0px !important;
    pointer-events: none !important;
    // line-height: 5 !important;
  }

  .img {
    position: relative;
    top: 5px;
    left: 8px;
    font-size: x-large;
    color: #979797;
  }

  .dropDown,
  .dropDown:hover {
    width: -webkit-fill-available !important;
    padding: 5px !important;
    cursor: pointer;
  }

  .dropDown:hover .dropdown-content {
    display: block;
    height: max-content;
  }

  .dropdown-content {
    display: none;
    position: relative;
    background-color: #ffffff;
    box-shadow: 0 0 11px 0 #e1e1e1;
    text-align: start;
    margin-top: 2px;
  }

  .dropdown-content li {
    list-style: none;
    margin: 0;
  }

  ul {
    padding-left: 0px;
    margin: 0px;
  }

  .dropdownLabel {
      font-family: "Roboto !important";
    font-size: 14px;
    padding-left: 16px;
    height: 40px;
    margin: 0px;
    line-height: 3;
  }

  .dropdown-content li:hover {
    background-color: #f4f4f4;
  }

  .fa-angle-down {
    transform: rotate(0deg);
  }

  .fa-angle-down.open {
    transform: rotate(180deg);
  }

  .buttonDiv {
    width: inherit;
    border-bottom: 1px solid #e1e1e154;
  }

  .onlyBottom {
    width: inherit;
    border-bottom: 1px solid #e1e1e154;
  }

  .round {
    position: relative;
    border-radius: 50% !important;
    border: 1px solid var(--brown-grey);
    height: 39px;
    width: 39px;
    padding: 0px !important;
    cursor: pointer;
    outline: 0 !important;
    background-color: white !important;

    .icon {
      width: 16px;
      height: 16px;
      opacity: 0.5;
      position: absolute;
      top: 10px;
      left: 10px;
    }
  }

  .round:hover {
    .icon {
      opacity: 1;
    }
  }

  .rounded-square {
    border-radius: 20% !important;
    padding: 6px;
    cursor: pointer;
    outline: 0 !important;
    box-shadow: 0 0 11px 0 #e1e1e1;
    background-color: white !important;
  }


  .round-title {
    font-weight: bold !important;
    position: inherit;
    padding-left: 8px;
    padding-right: 8px;
    height: 39px;
    width: 39px;
  }

  .left-borders-square {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .right-borders-square {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .border-left {
    border-left: 1px solid var(--very-light-pink);
  }
</style>